import { render, staticRenderFns } from "./drafts.vue?vue&type=template&id=4c0f9f8f&scoped=true&"
import script from "./drafts.vue?vue&type=script&lang=ts&"
export * from "./drafts.vue?vue&type=script&lang=ts&"
import style0 from "./drafts.vue?vue&type=style&index=0&id=4c0f9f8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f9f8f",
  null
  
)

export default component.exports